import React, { ComponentProps, Suspense, lazy, useMemo } from "react"

import classNames from "classnames"

import { ColorScheme } from "shared/context/color-scheme/ColorScheme"
import { Skeleton } from "shared/ui/skeleton/Skeleton"

import "../styles/_markdown.scss"
import { MarkdownImage } from "./MarkdownImage"
import { MarkdownLink } from "./MarkdownLink"
import { MarkdownParagraph } from "./MarkdownParagraph"

const MDPreview = lazy(() => import("@uiw/react-markdown-preview"))

export interface MarkdownPreviewProps {
  value?: string | null
  className?: string
  theme?: ColorScheme
  components?: ComponentProps<typeof MDPreview>["components"]
}

const defaultComponents: ComponentProps<typeof MDPreview>["components"] = {
  a: MarkdownLink,
  img: MarkdownImage,
  image: MarkdownImage,
  p: MarkdownParagraph
}

export const MarkdownPreview = React.memo(
  React.forwardRef(
    (
      { className, value, components }: MarkdownPreviewProps,
      ref: React.ForwardedRef<HTMLDivElement>
    ) => {
      const resolvedComponents = useMemo(
        () => ({ ...defaultComponents, ...components }),
        [components]
      )

      return (
        <div ref={ref} className={classNames("markdown-preview", className)}>
          <Suspense fallback={<Skeleton count={6} />}>
            <MDPreview source={value || ""} components={resolvedComponents} />
          </Suspense>
        </div>
      )
    }
  )
)
